module.exports = __webpack_public_path__ + "static/media/animal-elephant.f284dbb2.png";